<div class="key-options-wrapper" tabindex="-1" [class.d-none]="!isShowOptions" *ngIf="options && options.length">
  <div class="options-scroll-content">
    <label for="{{id}}" (click)="optionsList.focus()" class="sr-only">{{label}}</label>
    <ul id="{{id}}" attr.aria-label="{{label}}" role="listbox" tabindex="-1" #optionsList>
      <a *ngFor="let option of options; let i = index;"
      href="javascript:void(0)" role="option" tabindex="-1"
      (click)="onClickOption(option)"
      (keydown.enter)="onClickOption(option)"
      aria-disabled="false"
      attr.aria-selected="{{currentViewedOptionIndex === i}}"
      attr.data-index="{{i}}">
        <li>{{option}}</li>
      </a>
    </ul>
  </div>
</div>